window.customisers = []
window.presetPersoCount = 0;

if(window.customisation_products.length > 0){
    function renderCustomiser(singleId){
        setTimeout(() => {
            window.customisation_products.forEach(function(product){
                if(singleId != null){
                    if(singleId == product.id){
                        window.customisers[product.html_id] = window.createProductCustomiser(product.id,product.handle,product.html_id)
                        window.customisers[product.html_id].prod_price = parseInt($('.price-cont-'+product.html_id).attr('data-variant-price'))
                        window.customisers[product.html_id].cust_price = parseInt($('.customisers-inhouse').attr('data-variant-price'))
                    }
                } 
                else {
                    window.customisers[product.html_id] = window.createProductCustomiser(product.id,product.handle,product.html_id)
                    window.customisers[product.html_id].prod_price = parseInt($('.price-cont-'+product.html_id).attr('data-variant-price'))
                    window.customisers[product.html_id].cust_price = parseInt($('.customisers-inhouse').attr('data-variant-price'))
                }
            })
            window.resetCustomiser = function(html_id){
                $('.customisation-'+html_id+' .hero-select').val('-')
                $('.customisation-'+html_id+' .name-select').val('')
                $('.customisation-'+html_id+' .number-select').val('')
                $('.customisation-'+html_id+' .radio-badge.default').trigger('click')
                $('.customisation-'+html_id+' .step').removeClass('active')
                $('.customisation-'+html_id+' .step[data-step="1"]').addClass('active')
                $('.customisation-'+html_id+'').attr('data-variant-badge-price', 0)
                window.customisers[html_id].reset()
                var price = Shopify.formatMoney(window.customisers[html_id].prod_price+window.customisers[html_id].cust_price, window.cartStrings.moneyFormat)
                $('.price-'+html_id).html(price)
                $('.modal__inner .product__base-price').html(price)
                $('.js-current-price').html(price)
            }

            $('body').off('customiser_init')

            $('body').on('customiser_init', function(e,html_id) {

                $('.cb-'+html_id+' .customisation-buttons').addClass('active')

                $('body').on('click',`.customisation-${html_id} .no-badge`,function(e){
                    var group = $(this).attr('data-radio')
                    $('body').find('[data-radio="'+group+'"]').removeClass('active')
                    $(this).addClass('active')
                    window.customisers[html_id].resetBadge()
                })

                $('body').on('click',`.customisation-${html_id} .add-badge`,function(e){
                    var group = $(this).attr('data-radio')
                    $('body').find('[data-radio="'+group+'"].no-badge').removeClass('active')

                     if(!$(this).hasClass('active')){
                        $(this).addClass('active')
                        if($(this).attr('data-single') == 'true'){
                            let currentItem = $(this)
                            $('body').find('[data-radio="'+group+'"].radio-badge[data-single="true"]').each(function(index, radio) {
                                if(currentItem[0] != $(this)[0] && $(this).hasClass('active')){
                                    $(this).click()
                                }
                            });
                        }
                        window.customisers[html_id].setBadge($(this).attr('data-value'),$(this).attr('data-name'), $(this).attr('data-id'), $(this).attr('data-price'), $(this).attr('data-variant-id'))
                     } else {
                        $(this).removeClass('active')
                        window.customisers[html_id].resetBadge($(this).attr('data-id'));
                        
                        if(!$('body').find('[data-radio="'+group+'"]').hasClass('active')){
                            $('body').find('[data-radio="'+group+'"].no-badge').click();
                        }
                     }
                })
                window.customisers[html_id].onRender = function(){
                    var excludeNumber = false;
                    if ($('.customisation-' + html_id).data('exclude-numbers') !== undefined) {
                        excludeNumber = true;
                    }
                    $('.customisation-'+html_id+' .name-select').val(window.customisers[html_id].customisation.name)
                    $('.customisation-'+html_id+' .number-select').val(window.customisers[html_id].customisation.number)
                    if(
                        (excludeNumber === false && window.customisers[html_id].customisation.name !== '' && window.customisers[html_id].customisation.number !== '')
                        || (excludeNumber === true && window.customisers[html_id].customisation.name !== '')
                    ) {
                        $('.customisation-'+html_id+' .next-button').removeAttr('disabled')
                    }
                    else{
                        $('.customisation-'+html_id+' .next-button').attr('disabled',true)
                    }
                }
                $('body').on('click','.cb-'+html_id+' .personalised-product',function(e){

                    $('.purchase-buttons-'+html_id+' button').attr('disabled',true)
                    if($(this).hasClass('finished')){
                    $('.cb-'+html_id+' .summary').removeClass('hide')
                    $('.add-'+html_id).addClass('customised')
                    $('.add-'+html_id).removeAttr('disabled')
                    }
                    else{
                        $('.cb-'+html_id+' .customiser-options').removeClass('hide');
                        if ($('.cb-'+html_id+' .customiser-options .diy-product').hasClass('hide') || $('.cb-'+html_id+' .customiser-options .hero-product').hasClass('hide')) {
                            $('.cb-'+html_id+' .customiser-options .customiser-button:not(.hide)').trigger('click');
                        }
                    }
                    $('.add-'+html_id).removeClass('ajax-submit')
                    var details = window.customisers[html_id].getCartDetails().main
                    var price = window.customisers[html_id].prod_price+window.customisers[html_id].cust_price
                    if(details._badge_name.length){
                        price = window.customisers[html_id].prod_price+window.customisers[html_id].cust_price+parseInt($('.customisation-'+html_id+'').attr('data-variant-badge-price'))
                    }
                    price = Shopify.formatMoney(price, window.cartStrings.moneyFormat)
                    $('.price-'+html_id).text(price)
                    $('.modal__inner .product__base-price').text(price)
                    if($('.cb-'+html_id+' style[hide-buttons]').length == 0){
                    $('.cb-'+html_id+'').append('<style hide-buttons>.buttons-'+html_id+' .shopify-payment-button{display:none!important}</style>')
                    }
                })
                $('body').on('click','.cb-'+html_id+' .standard-product',function(e){

                    $('.cb-'+html_id+' .customiser-options').addClass('hide')
                    $('.purchase-buttons-'+html_id+' button').removeAttr('disabled')
                    $('.add-'+html_id).addClass('ajax-submit')
                    $('.cb-'+html_id+' .summary').addClass('hide')
                    $('.add-'+html_id).removeClass('customised')
                    var price = Shopify.formatMoney(window.customisers[html_id].prod_price, window.cartStrings.moneyFormat)
                    $('.price-'+html_id).html(price)
                    $('.modal__inner .product__base-price').html(price)
                    if($('.cb-'+html_id+' style[hide-buttons]').length != 0){
                    $('.cb-'+html_id+' style[hide-buttons]').remove()
                    }
                })
                $('body').on('click','.cb-'+html_id+' .diy-product',function(e){
                    $('.customisation-backing').toggleClass('active')
                    $('.customisation-'+html_id).toggleClass('active')
                    window.customisers[html_id].setHeroOrCustom('custom')
                    $('.customisation-'+html_id+' .title-hero').addClass('hide')
                    $('.customisation-'+html_id+' .steps-hero').addClass('hide')
                    $('.customisation-'+html_id+' .title-custom').removeClass('hide')
                    $('.customisation-'+html_id+' .steps-custom').removeClass('hide')
                    resetCustomiser(html_id)
                })
                $('body').on('click','.cb-'+html_id+' .hero-product',function(e){
                    $('.customisation-backing').toggleClass('active')
                    $('.customisation-'+html_id).toggleClass('active')
                    window.customisers[html_id].setHeroOrCustom('hero')
                    $('.customisation-'+html_id+' .title-hero').removeClass('hide')
                    $('.customisation-'+html_id+' .steps-hero').removeClass('hide')
                    $('.customisation-'+html_id+' .title-custom').addClass('hide')
                    $('.customisation-'+html_id+' .steps-custom').addClass('hide')
                    resetCustomiser(html_id)
                })
                $('.customisation-'+html_id+' .step h4').click(function(e){
                    $('.customisation-'+html_id+' .step').removeClass('active')
                    $(this).parents('.step').toggleClass('active')
                })
                $('.customisation-'+html_id+' .name-select').keyup(function(e){
                    window.customisers[html_id].setName($(this).val())
                })
                $('.customisation-'+html_id+' .number-select').keyup(function(e){
                    window.customisers[html_id].setNumber($(this).val())
                })
                $('.customisation-'+html_id+' .hero-select').change(function(e){
                    if($(this).val() !== '-'){
                        window.customisers[html_id].setName($(this).find('option:selected').attr('data-name'))
                        window.customisers[html_id].setNumber($(this).find('option:selected').attr('data-number'))
                    }
                    else{
                        window.customisers[html_id].setName('')
                        window.customisers[html_id].setNumber('')
                    }
                })
                $('.customisation-'+html_id+' .next-button').click(function(e){
                    $('.cb-'+html_id+' .personalised-product').addClass('finished')
                    $('.cb-'+html_id+' .summary').removeClass('hide')
                    var details = window.customisers[html_id].getCartDetails().main
                    Object.keys(details).forEach(function(key,index) {
                        if(key == '_badge_name'){
                            $('.cb-'+html_id+' .'+key+' .value').text((details[key].length ? details[key].toString().replace(',', ', ') : 'N/A'))
                        } else {
                            $('.cb-'+html_id+' .'+key+' .value').text((details[key] ? details[key] : 'N/A'))
                        }
                    })
                    $('.cb-'+html_id+' .customiser-options').addClass('hide')
                    $('.customisation-backing').toggleClass('active')
                    $('.customisation-'+html_id).toggleClass('active')
                    $('.cb-'+html_id+' .diy-product').removeClass('active')
                    $('.cb-'+html_id+' .hero-product').removeClass('active')
                    $('.add-'+html_id).addClass('customised')
                    $('.add-'+html_id).removeAttr('disabled')
                    var price = window.customisers[html_id].prod_price+window.customisers[html_id].cust_price
                    if(details._badge_name.length){
                        price = window.customisers[html_id].prod_price+window.customisers[html_id].cust_price+parseInt($('.customisation-'+html_id+'').attr('data-variant-badge-price'))
                    }
                    price = Shopify.formatMoney(price, window.cartStrings.moneyFormat)
                    $('.price-'+html_id).html(price)
                    $('.modal__inner .product__base-price').html(price)
                    $('.js-current-price').text(price)
                })
                $('body').on('click','.add-'+html_id+'.customised',function(e){
                    e.preventDefault();
            
                    var btn = $(e.target).closest('button'); 
                    var form = btn.closest('form'); 
                    var details = window.customisers[html_id].getCartDetails()
                    var main_prod = $('#product-select-'+html_id).val()
                    var cust_prod = $('.customisers-inhouse').attr('data-variant')
                    var items = []
                    var quantity = parseInt($('.quantity-'+html_id).val())
                    var id = new Date().getTime()
                    id = ''+id
                    var newId = id
                    var newDetails = details.main
                    newDetails._id = newId

                    if(details.main._badge_name.length && window.customisers[html_id].customisation.activeBadges.length){
                        $(window.customisers[html_id].customisation.activeBadges).each((index, badge) => {
                            items.push({
                                id: badge.id,
                                quantity: quantity,
                                properties: {
                                _id: newId
                                }
                            })
                        });
                    }
            
                    items.push({
                        id: cust_prod,
                        quantity: quantity,
                        properties: {
                        _id: newId
                        }
                    })
            
                    items.push({
                        id: main_prod,
                        quantity: quantity,
                        properties: newDetails
                    })

                    CartJS.addItems(items, {
                        success: (data, textStatus, jqXHR) => {

                            btn.addClass("disable-while-adding");
        
                            const openQuickViewModal = document.querySelector('.js-modal.is-active');
        
                            if (!!openQuickViewModal) {
                            openQuickViewModal.classList.remove('is-active');
                            }
                            $(data?.items).each((index, item) => {
                                $.ajax({
                                    method: "GET",
                                    url: "/products/" + item.handle + "?variant=" + item.variant_id + "&view=cart-item",
                                    dataType: "html",
                                    success: (html) => {
                                    //based on this class, we will style the mobile cart differently, but only when adding a product.
                                    $("#mini-cart-container").addClass("added-product");
                                    //if ajax call was successfull, add to the cart
                                    $(".cart-items-container").prepend(html);
                                    //remove any previous ajax messages.
                                    $('.cart-item[data-variant-id="' + item.variant_id + '"]')
                                        .find(".cart-ajax-message")
                                        .remove();
        
                                    $('.cart-item[data-variant-id="' + item.variant_id + '"]').addClass('personalised-product');
        
                                    $('.cart-item[data-variant-id="' + item.variant_id + '"]').addClass("newly-added");
                                    //Show add to cart message
                                    $('.cart-item[data-variant-id="' + item.variant_id + '"]:first-of-type').append(
                                        '<div class="cart-ajax-message added-to-bag">' + window.icons.tickSolid + "<p>" + window.cartStrings.addedToBag + "</p></div>"
                                    );
                    
                                    //update the quantity
                                    $('.cart-item[data-variant-id="' + item.variant_id + '"] .item-quantity').text(quantity);
                    
                                    //BG: if below 10, update mobile quantity too.
                                    if (quantity <= 10) {
                                        $('.cart-item[data-variant-id="' + item.variant_id + '"] .cart-item-quantity.mobile select').val(quantity);
                                    }
                    
                                    $('.cart-item[data-variant-id="' + item.variant_id + '"] .item-quantity--pdp').attr("value", quantity);
                    
                                    if (quantity >= 1) {
                                        $('.cart-item--pdp[data-variant-id="' + item.variant_id + '"] button[data-quantity-function="decrease"').attr("disabled", false);
                    
                                        $(".cart-item--pdp .cart-item-final-price span").text(
                                        Shopify.formatMoney($(".cart-item--pdp .cart-item-final-price span").data("money") * quantity, window.cartStrings.moneyFormat)
                                        );
                    
                                        $('.cart-item--pdp[data-variant-id="' + item.variant_id + '"] .discounted-price').html(
                                        Shopify.formatMoney($(".cart-item--pdp .discounted-price").data("money") * quantity, window.cartStrings.moneyFormat)
                                        );
                    
                                        $('.cart-item--pdp[data-variant-id="' + item.variant_id + '"] .standard-price').text(
                                        Shopify.formatMoney($(".cart-item--pdp .standard-price").data("money") * quantity, window.cartStrings.moneyFormat)
                                        );
                                    }
                    
                                    setTimeout(function () {
                                        $('.cart-item[data-variant-id="' + item.variant_id + '"] .cart-ajax-message.added-to-bag').slideUp(400);
                                        $('.cart-item[data-variant-id="' + item.variant_id + '"] .cart-ajax-message.added-to-bag').remove();
        
                                    }, 3000);
                    
                                    //update the cart details - pricing/discounts
                                    cartOutput(true, CartJS.cart);
                                    //re-enable the click events
                                    cartItems();
                    
                                    //Open the mini Cart
                                    miniCart.open();

                                    if($('body').hasClass('no-scroll')){
                                        $('body').removeClass('no-scroll')
                                    }
                    
                                    const optionValues = $('.cart-item[data-variant-id="' + item.variant_id + '"]:first-of-type').find(".js-option-value");
                    
                                    optionValues.each(function (index) {
                                        $(this).text(item.options_with_values[index].value);
                                    });
                    
                                    //if successful, remove disable from button.
                                    btn.removeClass("disable-while-adding");
                                    btn.prop("disabled", false);
                    
                                    setTimeout(function () {
                                        miniCart.close();
                                    }, 6000);
                    
                                    var quantityInput = $(form).find(".quantity__input"),
                                        quantityMaxQuantity = parseInt(quantityInput.attr("max")),
                                        addButtonText = btn.find("span");
                    
                                    if (quantity >= quantityMaxQuantity) {
                                        addButtonText.text(window.variantStrings.soldOut);
                                        btn.prop("disabled", true);
                                        btn.addClass("product__oos");
                                        btn.addClass("btn--secondary");
                                        btn.removeClass("btn--primary");
                                    }
                                    },
                                });
                            });
                        }
                    })
            
                    
                })
                $('body').on('click','.customisation-backing',function(){
                    $('.customisation-backing').removeClass('active')
                    $('.customisation-'+html_id).removeClass('active')
                    resetCustomiser(html_id)
                    $('.cb-'+html_id+' .diy-product').removeClass('active')
                    $('.cb-'+html_id+' .hero-product').removeClass('active')
                })
                $('body').on('click','.customisation-'+html_id+' .close-customiser',function(){
                    $('.customisation-backing').toggleClass('active')
                    $('.customisation-'+html_id).toggleClass('active')
                    resetCustomiser(html_id)
                    $('.cb-'+html_id+' .diy-product').removeClass('active')
                    $('.cb-'+html_id+' .hero-product').removeClass('active')
                })
                $('body').on('click','.customisation-'+html_id+' .cancel',function(){
                    $('.customisation-backing').toggleClass('active')
                    $('.customisation-'+html_id).toggleClass('active')
                    resetCustomiser(html_id)
                    $('.cb-'+html_id+' .diy-product').removeClass('active')
                    $('.cb-'+html_id+' .hero-product').removeClass('active')
                })
                $('.cb-'+html_id+' .summary .reset').click(function(e){
                    $('.purchase-buttons-'+html_id+' button').attr('disabled',true)
                    $('.add-'+html_id).removeClass('customised')
                    $('.cb-'+html_id+' .summary').addClass('hide')
                    $('.cb-'+html_id+' .personalised-product').removeClass('finished')
                    resetCustomiser(html_id)
                    $('.cb-'+html_id+' .customiser-options').removeClass('hide')
                })

                /* LH: Preset personalisation with params */
                let presetPerso = {
                    url: new URL(window.location.href),
                    productForm: document.querySelector('.product__main .product-form'),
                    block: document.querySelector('.product__main .customiser-block'),
                    customisationId: null,
                    customisation: '',
                    attempts: 0,
                    init(){
                        let params = this.url.searchParams,
                        perso = params.get('perso'), // Get perso parameter value
                        player = params.get('player') ? params.get('player').toLowerCase() : ''; // Get player parameter value

                        if(perso == "true" && player != null){
                            this.customisationId = html_id;
                            let customisationEl = document.querySelector(`.customisation-${this.customisationId}`); // Set customisation element

                            // If valid selector, set customisation object variable and call select options to begin automatic customisation
                            if(customisationEl != null){
                                this.customisation = customisationEl;
                                this.selectOptions(player);
                            }
                        }
                    },
                    selectOptions(player){
                        let persoButton = this.block.querySelector('.personalised-product'),
                        standardButton = this.block.querySelector('.standard-product'),
                        playerButton = this.block.querySelector('.hero-product'),
                        playerSelect = this.customisation.querySelector('.hero-select'),
                        playerSelectOptions = playerSelect.querySelectorAll('.hero-select option'),
                        confirmButton = this.customisation.querySelector('.next-button'),
                        cancelButton = this.customisation.querySelector('.cancel'),
                        editButton = this.block.querySelector('.summary .reset'),
                        nameMatch = false;

                        // Go through defined variables and begin programatically customising the product

                        persoButton && persoButton.click();

                        playerButton && playerButton.click();

                        playerSelectOptions.length && playerSelectOptions.forEach((option, index) => {
                        // Check for name attribute on an option
                            if(option.dataset.name){
                                let name = option.dataset.name.toLowerCase();

                                // Compare option name attribute with player parameter value
                                if(name == player){
                                // Define variables for images defined in product__images.liquid by looping through product.metafields.custom.player.value
                                let playerImages = document.querySelectorAll('.player-perso-gallery-image'),
                                playerThumbImages = document.querySelectorAll('.player-perso-gallery-thumbnail-image'),
                                event = new Event('change');
                                nameMatch = true;
                                // Set player select value
                                playerSelect.value = option.value;
                                // Loop through thumbnail images anc check if the data-title attribute contains the player name
                                playerThumbImages.length && playerThumbImages.forEach(image => {
                                    if(image.dataset.title.toLowerCase().includes(name)){
                                    let thumbFlkty = new Flickity('.js-thumb-product-images');
                                    // Show image
                                    image.style.display = 'flex';
                                    // Add image to thumbnail slider
                                    thumbFlkty.prepend(image);
                                    // Select corresponding slide
                                    thumbFlkty.selectCell(0, false, true)
                                    return;
                                    }
                                });

                                // Loop through main product images and check if the data-title attribute contains the player name
                                playerImages.length && playerImages.forEach(image => {
                                    if(image.dataset.title.toLowerCase().includes(name)){
                                    let mainFlkty = new Flickity('.js-product-images');
                                    // Show image
                                    image.style.display = 'flex';
                                    // Add image to main product images slider
                                    mainFlkty.prepend(image);
                                    // Select corresponding slide
                                    mainFlkty.selectCell(0, false, true)
                                    return;
                                    }
                                });
                                playerSelect.dispatchEvent(event);
                                confirmButton && confirmButton.click();
                                if(editButton) editButton.style.display = 'none';
                                return;
                                }
                            }
                            // If we are in the last loop and there is no name match in the options available, close the customisation and select the standard option
                            if(playerSelectOptions.length - 1 == index && !nameMatch){
                            cancelButton && cancelButton.click();
                            standardButton && standardButton.click();
                            }
                        });
                    }
                }

        
                // Check if the function hasn't been ran before, the customisation init is for the main product and we are on the product page

                let productMain = document.querySelector(`.cb-${html_id}`)?.closest('.product__main');

                if(window.presetPersoCount == 0 && !!productMain && window.location.pathname.includes('/products')){
                    presetPerso.init();
                    window.presetPersoCount++
                }
    
            })
        })
    }

    if($('body section.product .product__main').length > 0){
        let mainForm = document.querySelector('section.product .product__main .product-form');
        let mainId = mainForm.getAttribute('data-product-id');
        $(document).ready(
            setTimeout(() => {
                renderCustomiser(mainId);
            }, 500)
        );
    }

    window.renderCustomiser = (productId) => renderCustomiser(productId);
  }